import { addDays, isWithinInterval } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import { enGB } from 'react-day-picker/locale';
import { useSelector } from 'react-redux';
import { filteredHolidaysWithCheapestSelector } from '../../redux/data/cachedAvail/derivedSelectors';
import { minPricesMonthsSelector } from '../../redux/data/cachedAvail/selectors';
import {
  searchFormArrivalDateDateSelector,
  searchFormChannelIdSelector,
  searchFormDurationSelector,
} from '../../redux/search/form/selectors';
import { CustomNextButton, CustomPreviousButton } from './DatePickerComponents';

export const DatePicker = ({ handleDateChange }) => {
  const channelId = useSelector(searchFormChannelIdSelector);
  const duration = parseInt(useSelector(searchFormDurationSelector));
  const months = useSelector(minPricesMonthsSelector);
  const arrivalDate = useSelector(searchFormArrivalDateDateSelector);
  const filteredHolidaysWithCheapest = useSelector(filteredHolidaysWithCheapestSelector);

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const findPriceForDate = (targetDate) => {
    const formatDate = (date) => date.toLocaleDateString('en-GB'); // gives "DD/MM/YYYY"
    const formattedTarget = formatDate(targetDate);
    return filteredHolidaysWithCheapest.find(({ date }) => date === formattedTarget);
  };

  // Get the last end month
  const lastMonthStr = months[months.length - 1]; // e.g. '2027-01'
  const [year, month] = lastMonthStr.split('-').map(Number);
  const endMonthDate = new Date(year, month - 1);

  return (
    <DayPicker
      mode="single"
      required
      locale={enGB}
      onSelect={handleDateChange}
      calendarStartDay={2}
      startMonth={new Date()}
      endMonth={endMonthDate}
      defaultMonth={arrivalDate}
      selected={arrivalDate}
      navLayout="around"
      fixedWeeks
      disabled={[
        { before: tomorrow },
        (date) => (channelId === 'ukcaravan' ? !findPriceForDate(date) : ''), // disable days without a price
      ]}
      components={{
        PreviousMonthButton: CustomPreviousButton,
        NextMonthButton: CustomNextButton,
        DayButton: ({ day, ...buttonProps }) => {
          const actualDate = day?.date instanceof Date ? day.date : day;
          const data = findPriceForDate(actualDate);
          const price = data?.price;
          const isPartOfHoliday = isWithinDays(arrivalDate, actualDate, duration);

          return (
            <button {...buttonProps} className={`${buttonProps.className} ${isPartOfHoliday ? 'part-of-holiday' : ''}`}>
              <div className={`text-center day-picker`}>
                <p className="day">{actualDate.getDate()}</p>
                {price && (
                  <p className={`price ${data?.cheapestInWeek ? 'cheap' : ''}`}>£{Number(price || 0).toFixed(0)}</p>
                )}
              </div>
            </button>
          );
        },
      }}
    />
  );
};

const isWithinDays = (arrivalDate, dayPickerDate, days) => {
  const targetDate = new Date(dayPickerDate);

  // We want different styling on the selected date so we add 1 to start date here
  return isWithinInterval(targetDate, {
    start: addDays(arrivalDate, 1),
    end: addDays(arrivalDate, days),
  });
};
